function initOnClick(){
  const initialClass = $('.featured-collections-carousel__item.is-selected .home_slick, .prd-recommend');
 initialClass.slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows:true,
    autoPlay:true,
    autoplaySpeed:3000,
    infinite: true,
    responsive: [
      {
        breakpoint: 1000,
        settings: {
          autoPlay:true,
          autoplaySpeed:2000,
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 700,
        settings: {
          autoPlay:true,
          autoplaySpeed:2000,
          slidesToShow: 2,
          slidesToScroll:1
        }
      }
    ]
  });
}
function destroySlick(){
  $('.home_slick').slick('unslick');
}
  
$(document).ready(function () {
  initOnClick();

  $('.page_handle_index .featured-collections-navigation .h2').on('click', function () {   
    setTimeout(function(){
    destroySlick();
    }, 100);
    setTimeout(function(){
      initOnClick();
    }, 500)
  });
});